import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './horariosvalores_diegoftv00.module.scss';
import { FaArrowLeft } from 'react-icons/fa';

const PLANOS = [
    { label: '1x na semana', valor: 'R$ 120,00' },
    { label: '2x na semana', valor: 'R$ 140,00' },
    { label: 'Aulas avulsas', valor: 'R$ 35,00' },
];

const HORARIOS = [
    { dia: 'Segunda-feira', itens: [{ hora: '06:00', turma: 'Masculino' }] },
    { dia: 'Terça-feira', itens: [{ hora: '06:00', turma: 'Feminino' }, { hora: '18:00', turma: 'Masculino' }] },
    { dia: 'Quarta-feira', itens: [{ hora: '06:00', turma: 'Masculino' }] },
    { dia: 'Quinta-feira', itens: [{ hora: '06:00', turma: 'Masculino' }, { hora: '18:00', turma: 'Feminino' }, { hora: '19:00', turma: 'Masculino' }] },
    { dia: 'Sexta-feira', itens: [{ hora: '06:00', turma: 'Feminino' }] },
    {
        dia: 'Sábado',
        itens: [
            { hora: '05:00, 06:00 e 07:00', turma: 'Feminino' },
            { hora: '08:00 e 09:00', turma: 'Masculino' },
        ],
    },
];

const Horariosvalores_diegoftv00: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.horariosvalores_diegoftv00}>
            <div className={styles.pageWrapper}>
                <div className={styles.horariosvalores_diegoftv00}>
                    <div className={styles.header}>
                        <Link to="/diegoftv00" className={styles.backButton} aria-label="Voltar">
                            <FaArrowLeft />
                        </Link>
                        <h1 className={styles.title}>Horários e Valores</h1>
                    </div>

                    <div className={styles.section}>
                        <h2 className={styles.sectionTitle}>Planos mensais</h2>
                        <ul className={styles.planosList}>
                            {PLANOS.map((item, index) => (
                                <li key={index} className={styles.planoItem}>
                                    <span className={styles.planoLabel}>{item.label}</span>
                                    <span className={styles.planoValor}>{item.valor}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className={styles.section}>
                        <h2 className={styles.sectionTitle}>Horários das turmas</h2>
                        <div className={styles.diasList}>
                            {HORARIOS.map((dia, index) => (
                                <div key={index} className={styles.diaCard}>
                                    <div className={styles.diaNome}>{dia.dia}</div>
                                    <ul className={styles.turmasList}>
                                        {dia.itens.map((item, i) => (
                                            <li key={i} className={styles.turmaItem}>
                                                <span className={styles.turmaHora}>{item.hora}</span>
                                                <span className={styles.turmaTipo}>({item.turma})</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={styles.catalogoWrap}>
                        <img
                            src={require('./src/catalogo.png')}
                            alt="Catálogo - Horários e planos"
                            className={styles.catalogoImage}
                        />
                    </div>

                    <div className={styles.footer}>
                        <img
                            src={require('./src/logo.png')}
                            alt="DS"
                            className={styles.footerLogo}
                        />
                        <img
                            src={require('./src/logo_topsoccer.png')}
                            alt="Top Soccer"
                            className={styles.footerLogo}
                        />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Horariosvalores_diegoftv00;
